import cn from 'classnames';
import { useState, Dispatch, SetStateAction, MouseEvent as MouseEventGeneric } from 'react';
import { connect, useDispatch } from 'react-redux';

import { captchaSetActionAfterTokenLoad, captchaSetIsActive } from 'CorePackage/CaptchaModule/actions/captchaActions';
import { getCaptchaToken } from 'CorePackage/CaptchaModule/selectors/captchaSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getCoreScreenSize } from 'CorePackage/MainModule/selectors/coreSelectors';
import { DropdownButton } from 'UIPackage/MainModule/components/DropdownButton';
import { IconMenu } from 'UIPackage/MainModule/components/IconMenu';

import { passportDecisionExportPdf } from '../../actions/passportKnmActions';
import styles from '../KnmHeader.module.scss';

interface IKnmHeaderProps {
  activeTab: string;
  setActiveTab: Dispatch<SetStateAction<string>>;
}

interface IKnmHeaderStoreProps {
  screenSize: string;
  captchaToken: string | null;
}

const DecisionHeaderComponent = ({
  activeTab,
  setActiveTab,
  captchaToken,
  screenSize,
}: IKnmHeaderProps & IKnmHeaderStoreProps) => {
  const dispatch = useDispatch();

  const tabs = [
    {
      name: 'common',
      text: 'Общая информация',
    },
    {
      name: 'control',
      text: 'Информация об органе контроля',
    },
    {
      name: 'prosecutor',
      text: 'Информация об органе прокуратуры',
    },
    {
      name: 'face',
      text: 'Сведения о контролируемом лице',
    },
  ];
  const [isRollUp, setIsRollUp] = useState(true);
  const isMobile = screenSize === 'mobile';

  const onExportPdf = () => {
    dispatch(captchaSetActionAfterTokenLoad(passportDecisionExportPdf));
    if (!captchaToken) {
      dispatch(captchaSetIsActive(true));
    } else {
      dispatch(passportDecisionExportPdf());
    }
  };

  const onClick = (e: MouseEventGeneric<HTMLButtonElement, MouseEvent> & { target: { id: string } }) =>
    setActiveTab(e.target.id);
  const onMenuButtonClick = () => setIsRollUp(prev => !prev);

  const renderMenuButton = () => (
    <button type="button" className={cn({ [styles.MenuButtonIsRollUp]: !isRollUp })} onClick={onMenuButtonClick}>
      <IconMenu />
    </button>
  );

  const dropDownItems = [
    {
      id: 'exportToPdf',
      content: (
        <span className="shared-dropdown-button" onClick={onExportPdf}>
          Экспорт в PDF
        </span>
      ),
    },
  ];

  const renderTabs = () => {
    if (isMobile && isRollUp) {
      const tab = tabs.find(x => activeTab === x?.name);
      return (
        <div className={styles.MobileRolledMenu}>
          <button
            key={tab?.name}
            className={cn(styles.TabItem, { [styles.TabActive]: true })}
            id={tab?.name}
            onClick={onClick}
            type="button"
            style={{ outline: 'none' }}
          >
            {tab?.text}
          </button>
          {renderMenuButton()}
        </div>
      );
    }
    return (
      <>
        <div className={styles.tabsWrapper}>
          {tabs.map(tab => {
            if (!tab) {
              return null;
            }
            return (
              <button
                key={tab.name}
                className={cn(styles.TabItem, { [styles.TabActive]: activeTab === tab.name })}
                id={tab.name}
                onClick={onClick}
                type="button"
                style={{ outline: 'none' }}
              >
                {tab.text}
              </button>
            );
          })}
        </div>
        <DropdownButton items={dropDownItems} />
      </>
    );
  };

  return (
    <div className={styles.KnmHeader}>
      <div
        className={cn(styles.Buttons, {
          [styles.IsRollUp]: isRollUp,
        })}
      >
        {renderTabs()}
      </div>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  screenSize: getCoreScreenSize(state),
  captchaToken: getCaptchaToken(state),
});

export const DecisionHeader = connect(mapStateToProps)(DecisionHeaderComponent);
